import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

function LegalPageLayout({
  titleId,
  icon,
  iconVariant = "default",
  title,
  description,
  children,
}) {
  const iconClassName = [
    "legal-hero-icon",
    iconVariant === "danger" ? "legal-hero-icon-danger" : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className="legal-page">
      <section className="legal-hero" aria-labelledby={titleId}>
        <FontAwesomeIcon
          icon={icon}
          className={iconClassName}
          aria-hidden="true"
        />
        <h1 id={titleId}>{title}</h1>
        <div>{description}</div>
      </section>
      <section className="legal-content">
        <div className="card-ms legal-document">
          <div className="card-ms-body">{children}</div>
        </div>
      </section>
    </div>
  );
}

export default LegalPageLayout;
